import React from 'react';
import { createConfirmation, type ConfirmableDialog } from 'react-confirm';
import ConfirmationDialog, { type ConfirmationDialogOwnProps } from '../ConfirmationDialog';

/**
 * Create a confirmation for discarding changes using react-confirm.
 *
 * `confirmable(ConfirmationDialog)` (in `../ConfirmationDialog`) widens the
 * dialog's caller-prop generic `P` to include react-confirm's injected
 * `proceed`/`cancel`/`show` props, so `createConfirmation` would otherwise demand
 * them from the caller. Re-type the wrapped component to the caller-facing prop
 * shape it actually accepts (`ConfirmationDialogOwnProps`, resolving `void`).
 * Type-only cast at this library-boundary; runtime component is unchanged.
 */
const confirm = createConfirmation(
  ConfirmationDialog as unknown as ConfirmableDialog<ConfirmationDialogOwnProps, void>
);

/**
 * Utility function to show a confirmation dialog before discarding changes.
 *
 * @param action the name of the action shown as the dialog title.
 */
export default function confirmDiscardChanges(action: string) {
  return confirm({
    confirmation: (
      <React.Fragment>
        <p>The inspector has unsaved changes. These changes will be lost if you continue.</p>
        <p>Are you sure you want to continue?</p>
      </React.Fragment>
    ),
    options: {
      title: action,
      proceedText: 'Discard changes & continue',
    },
  });
}
